import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId, usePartnerName } from '../../features/inbox/use-partner-name';
import { OperationsIndexStepper } from '../../features/operations/operations-index-stepper';
import { OperationsList } from '../../features/operations/operations-list';

export const Route = createFileRoute('/operations/')({
  // Parent /operations route already contributes the "Operations"
  // crumb — the index inherits it without re-emitting a duplicate.
  staticData: {
    layout: 'full-height',
  },
  component: OperationsListPage,
});

function OperationsListPage() {
  const partnerId = usePartnerId();
  const partnerName = usePartnerName();

  return (
    <div className="flex h-full min-h-0 flex-col">
      <OperationsIndexStepper />
      <div className="min-h-0 flex-1">
        <OperationsList partnerId={partnerId} partnerName={partnerName} />
      </div>
    </div>
  );
}
